<div class="body_container">
  <h4>User List</h4>
  <table class="table table-striped main-panel-table" style="white-space: nowrap;">
    <thead>
      <tr class="table-list-head">
        <th scope="col" resizable>#</th>
        <th scope="col" resizable>Deployment</th>
        <th scope="col" resizable>Total Users</th>
        <th scope="col" resizable>No. of Job Operators</th>
        <th scope="col" resizable>No. of Power Users</th>
        <th scope="col" resizable>No. of Deployment Admins</th>
      </tr>
    </thead>
    <tbody *ngIf="!dataEmpty">
      <tr class="table-list-row"
        *ngFor="let dep of deployments; let i = index"
        style="cursor: pointer; outline: none;"
        (click)="redirectTo(dep)"
      >
        <td scope="row">{{ i + 1 }}</td>
        <td class="impListName">{{ dep.name }}</td>
        <td>{{ dep.totalUsers }}</td>
        <td>{{ dep.totalJobOperators }}</td>
        <td>{{ dep.totalPowerUsers }}</td>
        <td>{{ dep.totalDeploymentAdmins }}</td>
      </tr>
    </tbody>
  </table>
  <p *ngIf="dataEmpty" style="text-align: center; margin-top: 5%;">No Deployment Available.</p>
  <ngx-spinner
    bdColor="rgba(0,0,0,0)"
    size="default" zIndex = "1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
    ><p class="pleaseWait">Please wait ...</p></ngx-spinner
  >
</div>
